import { Component, OnInit } from '@angular/core';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ChangeDetectorRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-terms-and-condition',
  templateUrl: './terms-and-condition.component.html',
  styleUrls: ['./terms-and-condition.component.scss']
})
export class TermsAndConditionComponent implements OnInit {
  data:any;
  sub_heading: any;
  sub_heading_text: any;
  question_section_one:any;
  question_section_two:any;
  ans_section_one:any;
  ans_section_two:any;
  activeTab:any = 0;
  selectedTab: number | null;
  constructor(private UTS: UtilitiesService,private APPIS: ApplicationInitializationService, private APPCMSIS: AppCmsUrlsInitializationService,private CCS:CmsContentService, private changeDetectorRef: ChangeDetectorRef, private modalController: ModalController) { }

    ngOnInit() {
      this.init();
    }
      init(){
        const cmsUrlCode = "TERMS_COND_POPUP";
        let CMS_URLS = this.APPCMSIS.appInitializer?.CMS_URLS;
        let CMS_URL, url;
      
        try {
          if (CMS_URLS && CMS_URLS.length > 0) {
            CMS_URL = CMS_URLS.find((c) => c.cmsUrlCode == cmsUrlCode);
            if (!CMS_URL) {
              console.error('No matching CMS URL found.');
            }
            url = this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL.cmsUrlEn;
          } else {
            console.error('CMS_URLS is empty or undefined.');
          }
        } catch (error) {
          console.error('Error:', error.message);
        }
        if (this.UTS.getLocaleLanguage() == 'ar')
          url =
            this.APPIS.environmentConfig?.CMS_URL_NEW_FRAGMENTPATH +
            CMS_URL?.cmsUrlAr;
             this.CCS.newFragemnetContentService(url).subscribe(
            (result: any) => {
              const { item } = result?.data?.nwtConsumerGenericModulesByPath || {};
              this.data = item?.consumerMainSection?.[0];
              
              if (this.data) {
                this.sub_heading = this.data?.description?.json?.[0]?.content?.[0]?.value;
                this.sub_heading_text = this.data?.description?.json?.[1]?.content?.[0]?.value;
              
                const faqSections = this.data?.faqSection || [];
                if (faqSections.length > 0) {
                  this.question_section_one = faqSections[0]?.questionSection;
                  this.ans_section_one = faqSections[0]?.answerSection;
                }
              
                if (faqSections.length > 1) {
                  this.question_section_two = faqSections[1]?.questionSection;
                  this.ans_section_two = faqSections[1]?.answerSection;
                }
              }
          },
          (error) => {
          }
        );
      }    

      close(){
        this.modalController
        .dismiss({
          dismissed: true,
        })
        .then(() => {
          this.updateContent();
        });
      }
      
      updateContent() {
        this.changeDetectorRef.detectChanges();
      }

      selectNav(index: number) {
        this.activeTab = index; 
      }

      selectTab(index: number) {
        if (this.selectedTab === index) {
          this.selectedTab = null;
        } else {
          this.selectedTab = index;
        }
        this.updateContent()
      }
}